import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
import axios from 'axios';

import CustomToaster from './CustomToaster';
import CustomAddButton from './CustomAddButton';
import AddToListButton from './AddToListButton';


const styles = theme => ({
  root: {
    display: 'flex',
    textAlign: 'left',
    margin: "5px",
  },
  cover: {
    width: "100px",
    height: "100px",
    "object-fit": "contain",
    margin: "auto",
  },
  name: {
    height: 70,
    overflow: "hidden",
    marginBottom: "10px",
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  buyButtons: {
    margin: "5px"
  },
  asideContainer: {
    height: "170px"
  },
  myRibbon: {
    margin: "0px",
    width: "100px",
    height: "100px",
    display: "block",
    position: "relative",
    float: "right",
    "z-index": 0
  },
  myRibbonSpan: {
    width: "150px",
    height: "34px",
    top: "20px",
    right: "-40px",
    position: "absolute",
    display: "block",
    background: "#FF0000",
    "font-family": "arial",
    "font-size": "22px",
    color: "white",
    "text-align": "center",
    "line-height": "34px",
    transform: "rotate(45deg)",
    "-webkit-transform": "rotate(45deg)",
    "-ms-transform": "rotate(45deg)"
  },
  contentDiv: {
    width: "100%"
  },
  detailsContent: {
    display: "flex",
    flex: '1 0 auto',
  },
  detailsDivContent: {
    margin: "auto"
  }
});

class ProductListCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      lang: this.props.lang,
      logged: this.props.logged,
      express: this.props.express,
      tariff: this.props.tariff,
      width: 0,
      height: 0,
      selectProductId: null,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      cart_product_ids: JSON.parse(this.props.cart_products.product_ids),
      fav_products: this.props.fav_products,
      fev_product_ids: JSON.parse(this.props.fav_products.fev_product_ids),
      jwt: this.props.jwt,
      api_origin: this.props.api_origin,
      api_url:this.props.api_url,
      stocks: this.props.stocks,
      customFilterManufacturerIds: this.props.customFilterManufacturerIds,
      sendAddEvent: this.props.sendAddEvent || false,
    };

    this.addToFav = this.addToFav.bind(this);
    this.goToExpress = this.goToExpress.bind(this);
    this.removeIdFromArr = this.removeIdFromArr.bind(this);
    this.addIdFromArr = this.addIdFromArr.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.manufacturerFilter = this.manufacturerFilter.bind(this);
  }

   //remove all characters except a-z0-9 
   manufacturerFilter= (manufacturer) => {
    let filtered = manufacturer.replace(/[^a-z0-9]/gi, '');   
    // return filtered replacing characters to lowercase    
    return filtered.toLowerCase(); 
  }

  goToExpress = () => {
    let newurl = window.location.protocol + "//" + window.location.host + "/" + "cart.php";
    window.location.href = newurl
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props.data
      });
    }
    if (this.props.stocks !== prevProps.stocks) {
      this.setState({
        stocks: this.props.stocks,
      });
    }
    if(this.props.cart_products !== prevProps.cart_products) {
      this.setState({
        cart_products: this.props.cart_products,
        cart_product_ids: JSON.parse(this.props.cart_products.product_ids),
      });
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  addIdFromArr(id){
    let arr = [];
    
    const old_ids = [...this.state.cart_product_ids];

    if (old_ids.indexOf(id) === -1)
    {
      old_ids.push(id);
    }
    this.setState({cart_product_ids: old_ids});
  }

  removeIdFromArr(id){
    let arr = [];
    const old_ids = this.state.cart_product_ids;
    old_ids.map((val) => {
      if(val != id){
        arr.push(val);
      }
    });
    
    this.setState({cart_product_ids: arr});

    // const old_ids = JSON.parse(this.state.cart_product_ids);
    // const newCartIds = old_ids.filter((cids) => cids !== id);
    // this.setState({cart_product_ids: newCartIds});
  }

  productHandler = async (id,manufacturer_id) => {

    let quantity = 1;
    const cartP = [ ...this.state.cart_product_ids,id ];
    this.setState({cart_product_ids: cartP});
    this.state.cart_products.prods_q[id] = "1";
    
    const data = JSON.stringify({
      "product_id": id,
      "quantity": quantity
    })
    
    let addPrdDetls = null;
    try {
      addPrdDetls = await WebuserCartApi.create({
       "product_id": id,
       "quantity": quantity
     });  
   } catch (error) {
     
   }
    
   this.setState({ alertType: "add" });
   this.setState({ headContent: "Product added" });


    if (addPrdDetls) {

      var event = new CustomEvent('updatePHPCart', {
        detail: {
          product_id: this.state.data.id.raw,
        }
      });
      
      window.dispatchEvent(event);

      this.setState({
        selectProductId: id
      });
      
      setTimeout(() => {
        this.setState({
          selectProductId: null
        })
      }, 3000);
    }
  }

  addToFav = async(e, stat) => {
    
    let p_id = this.state.data.id.raw;
    let product_id = {"product_id": p_id};

    if (stat) {

      const cartP = [ ...this.state.fev_product_ids, p_id ];
      this.setState({fev_product_ids: cartP});
      
      let addFevStat = await axios.post(this.state.api_url+`/webusers/favorites`,
      product_id,
      {   
        headers: {
          "Accept": "application/json, text/javascript, */*; q=0.01",
          "Authorization": this.state.jwt
        }
      });
  
      if (addFevStat) {
        this.setState({
          selectProductId: p_id
        });
        
        setTimeout(() => {
          this.setState({
            selectProductId: null
          })
        }, 3000);
        // alert("Fev Product added");
      }

    } else {

      let arr = [];
      const old_fav_ids = this.state.fev_product_ids;
      old_fav_ids.map((val) => {
        if(val != p_id){
          arr.push(val);
        }
      });

      this.setState({fev_product_ids: arr});

      /*const old_ids = JSON.parse(this.state.fev_product_ids);
      const newFevIds = old_ids.filter((cids) => cids !== p_id);
      this.setState({fev_product_ids: newFevIds});*/
      
      let rmvFevStat = await axios.delete(this.state.api_url+`/webusers/favorites/${p_id}`,
      {   
        headers: {
          "Accept": "application/json, text/javascript, */*; q=0.01",
          "Authorization": this.state.jwt
        }
      });
  
      if (rmvFevStat) {
        this.setState({
          selectProductId: p_id
        });
        
        setTimeout(() => {
          this.setState({
            selectProductId: null
          })
        }, 3000);
        // alert("Fev Product removed");
      }

    }
  }

  render() {
    const { classes } = this.props;
    const { width, data, lang, logged, express, tariff, selectProductId,client_country_id, cart_products, jwt, api_origin, api_url, stocks, customFilterManufacturerIds, sendAddEvent } = this.state;
    let producto = stocks?stocks.find(producto => producto.product_id === parseInt(data.id.raw)):null;
    let stock = (producto ? producto.stock : 0);
    let net = producto ? producto.net : 0;
    let pg = producto && producto.pg ? producto.pg.split('_')[1] || "" : "";
    let pvp = producto ? producto.price : 0;
    let in_offer = producto ? producto.in_offer : false;
    let in_offer_until = producto ? producto.in_offer_until : '0000-00-00';
    
    return (
      <>
        <TableCell colSpan={2} className="product-list-img">
          <div className={!logged ? "list-action-hide list-product-action" : "list-product-action"}>
            <div className="product-top-action">
              <Typography className="top-icon like-btn" >
                {this.state.fev_product_ids.includes(data.id.raw)
                ?
                  <img 
                    src="../../newDesigning/images/heart-icon.svg" 
                    alt="likeBtn"
					loading="lazy"
                    onClick={(e) => this.addToFav(e, false)}
                  />
                :
                  <img 
                    src="../../newDesigning/images/wishlist-gray.svg" 
                    alt="likeBtn"
					loading="lazy"
                    onClick={(e) => this.addToFav(e, true)}
                  />
                }
              </Typography>
              {
                /*TESTdata?.in_showroom?.raw == "true" &&*/
                (data?.common?.raw.includes("supportplus")) &&
                <Typography className="top-icon headphone-icon" component="span">
                  <img src="/img/svgs/headphone.svg" alt="headphone" loading="lazy"/>
                </Typography>
              }

              {/* <Typography className="top-icon" component="span">
                <img src="/img/svgs/wishlist.svg" alt="wishlist" />
              </Typography>   */}

              {
                /*IN SPECIAL OFFER*/
                (data?.common?.raw.includes("specialoffer")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>SPECIAL OFFER</Trans></Typography>
              }
              {
                /*IN PROMOTION*/
                (data?.common?.raw.includes("promotion")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>PROMOTION</Trans></Typography>
              }
              {
                /*BLACKFRIDAY OFFER*/
                (data?.common?.raw.includes("blackfriday")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>BLACK FRIDAY</Trans></Typography>
              }
              {
                /*ANNIVARSARY OFFER*/
                (data?.common?.raw.includes("anniversary")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>ANNIVERSARY OFFER</Trans></Typography>
              }      
              {
                /*STOCK CLEARANCE OFFER*/
                (data?.common?.raw.includes("stockclearance")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>STOCK CLEARANCE</Trans></Typography>
              }        
              {
                /*IN OFFER*/
                (!data?.common?.raw.includes("blackfriday")) && (!data?.common?.raw.includes("anniversary")) && (!data?.common?.raw.includes("specialoffer")) && (!data?.common?.raw.includes("stockclearance")) && (!data?.common?.raw.includes("promotion")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn offer-btn" variant="subtitle1" component="span"><Trans>OFFER</Trans></Typography>
              }


              {
                /*IN SPECIAL OFFER
                (data?.common?.raw.includes("specialoffer")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn btn-special" variant="subtitle1" component="span"><Trans>BLACK FRIDAY</Trans></Typography>
                */
              }
              
              {
                /*IN OFFER
                (!data?.common?.raw.includes("specialoffer")) && (data?.common?.raw.includes("inoffer")) &&
                <Typography className="btn offer-btn" variant="subtitle1" component="span"><Trans>OFFER</Trans></Typography>
                */
              }
              

              

              {
                data?.not_discontinued?.raw == "false" &&
                <Typography className="btn discontinued-btn" variant="subtitle1" component="span"><Trans>Discontinued</Trans></Typography>
              }
            </div>
          </div>
          <div className="list-link-wrap">
            <a href={"/producto.php?cod_producto=" + data.id.raw} className="sm-hide list-img-link" >
              {
                JSON.parse(data.product_data.raw).photo != "" ? (
                  <img className={"list-img " + classes.cover} 
                    /*src={JSON.parse(data.product_data.raw).photo}*/
                    src={'/common/fotos/'+this.manufacturerFilter(data.manufacturer.raw)+'/'+this.manufacturerFilter(data.ref1.raw)+'.jpg'}
                    alt={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names)[this.state.lang]}
					loading="lazy"
                    onError={(e) => { e.target.onerror = null; e.target.src = "/common/fotos/default.png" }}
                  />
                ) : (
                  <CardMedia
                    className={"list-img " + classes.cover}
                    image="/common/fotos/default.png"
                    component="img"
                  />
                )
              }
            </a>
          </div>
        </TableCell>
        <TableCell colSpan={width <= 1440 ? 5 : 4} className="product-name-block">
          <CardContent className={classes.content}>
            <article>
              <div className="rating-wrap">
                <div className={classes.contentDiv}>
                  <div className={`${classes.name} product-name-inner`}>
                    <a href={"/producto.php?cod_producto=" + data.id.raw} className="product-name" title={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names[this.state.lang])}>
                      <Typography className={"title " + classes.name} component="h5" variant="h5">
                        {(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names[this.state.lang])}
                      </Typography>
                    </a>
                  </div>
                  {/*<Typography className="graybg-btn" component="a" href={"/producto.php?cod_producto=" + data.id.raw}>
                        Ficha de producto
                      </Typography>*/}
                  {
                    data?.not_discontinued?.raw == "false" ? (
                      <Typography className="btn graybg-btn" component="a" href={"/producto.php?cod_producto=" + data.id.raw}><Trans>Watch</Trans></Typography>
                    ) : (
                      logged && client_country_id!='PT' && (JSON.parse(data.product_data.raw).manufacturer_id!=61 || JSON.parse(data.product_data.raw).manufacturer_id==182/*EAE*/) &&
                      // <Typography className="btn bluebg-btn addCarro" component="a" href="#" data-toggle="modal" data-producto={data.id.raw} data-target="#modalAdd"><Trans>Add</Trans></Typography>
                      <div className="mw-200">
                      <ul className="cardBtn">
                        {
                          JSON.stringify(this.state.cart_product_ids).includes(data.id.raw)
                          ?
                            <CustomAddButton 
                              data={data} 
                              jwt={jwt} 
                              cart_prods={this.state.cart_products.prods_q}
                              removeIdFromArr={this.removeIdFromArr}
                              addIdFromArr={this.addIdFromArr}
                              client_country_id={client_country_id}
                              api_origin={api_origin}
                              api_url={api_url}
                            />
                          :
                            <Typography 
                              className="btn bluebg-btn addCarro" 
                              component="a" 
                              onClick={() => this.productHandler(data.id.raw, JSON.parse(data.product_data.raw).manufacturer_id)}
                              data-producto={data.id.raw} 
                              data-value1={JSON.parse(data.product_data.raw).manufacturer_id}
                            >
                              <Trans>Add to</Trans>
                            </Typography>
                        }
                              <AddToListButton
                                jwt={jwt}
                                data={data}
                                api_origin={api_origin}
                                api_url={api_url}
                              />
                            </ul>
                      </div>

                    )
                  }
                  
                </div>
              </div>
            </article>
          </CardContent>
          <div className="toast-notification" >
            <div className="toast-card" data-target={`toast-${data.id.raw}`} style={selectProductId == data.id.raw ? { display: 'block' } : { display: 'none' }}>
              <div className="toast-progress">
                <span></span>
              </div>
              <div className="toast-heading">
                <p className="fh4"><Trans>Product added</Trans></p>
              </div>
              <div className="toast-content box-shadow-strip-wrapper">
                <div className="image-block">
                  <img 
                    /*src={JSON.parse(data.product_data.raw).photo} */
                    src={'/common/fotos/'+this.manufacturerFilter(data.manufacturer.raw)+'/'+this.manufacturerFilter(data.ref1.raw)+'.jpg'}
                    alt={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names[this.state.lang])}
                    onError={(e) => { e.target.onerror = null; e.target.src = "/common/fotos/default.png" }}
                  />
                  {/*<img src="images/order-item.jpg"  />*/}
                </div>
                <div className="content-block">
                  <p><a href={`/producto.php?cod_producto=${data.id.raw}`} title={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names[this.state.lang])}>{(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[this.state.lang] : JSON.parse(data.product_data.raw).names[this.state.lang])}</a></p>
                  <button className="blue-btn" onClick={() => this.goToExpress()}><Trans>Checkout</Trans></button>
                </div>
              </div>
              <div className="toast-footer">
                <p><Trans>Some units on request from the manufacturer</Trans></p>
              </div>
            </div>
          </div>
        </TableCell>
        <TableCell colSpan={width <= 1024 ? 2 : width <= 1280 ? 1 : 2} className="rating-wrap-col">
          <a href={"/producto.php?cod_producto=" + data.id.raw} className="product-link">
            <div className="rating-wrap">
              <Typography variant="body2" component="p" className="code-txt"><Trans>Code</Trans>: {data.webcode.raw} · <Trans>{data?.manufacturer?.raw}</Trans></Typography>
              <Typography variant="body2" component="p" className="ref-txt"><Trans>Ref</Trans>.: {data.ref1.raw} </Typography>
              <div className="offer-valid-block">

                {
                  logged ? (
                     express ? ( 
                      <Typography variant="body2" component="p" className="pvp-txt pvp-unstock">
                        <Trans>List price</Trans>: {pvp < 0.01 ? '* Request price' : pvp.toFixed(2)} €
                      </Typography>
                     ):(
                      <Typography variant="body2" component="p" className="offer-txt">
                      <Trans>List price</Trans>: {pvp < 0.01 ? '* Request price' : pvp.toFixed(2)} €
                    </Typography>
                     )

                  ) : (
                    <Typography variant="body2" component="p" className="pvp-txt">
                      <Trans>List price</Trans>: <a href="#" data-popup="setting-popup2" className="login_txt popup-link"><Trans>You must be logged in</Trans></a>
                    </Typography>
                  )
                }


                <div className="offer-valid-info">
                  {
                    logged ? (
                     
                          express ? (
                            <Typography variant="body2" component="span" className="offer-txt">
                            {
                              (data?.common?.raw.includes("inoffer")) ? (
                                <div><Trans>Offer</Trans>: <Typography variant="body2" component="span" className="offer-price">{net < 0.01 ? <Trans>* Request price</Trans> : net.toFixed(2)} € - { pg }</Typography></div>
                              ) : (
                                <div><Trans>Net Price</Trans>: <Typography variant="body2" component="span" className="offer-price">{net < 0.01 ? <Trans>* Request price</Trans> : net.toFixed(2)} € - { pg }</Typography></div>
                              )
                            }
                            </Typography>

                          ):(
                            <Typography variant="body2" component="span" className="pvp-txt">
                            {
                              (data?.common?.raw.includes("inoffer")) ? (
                                <div><Trans>Offer</Trans>: <Typography variant="body2" component="span" className="offer-price"> <Trans>* Request price</Trans> €</Typography></div>
                              ) : (
                                <div><Trans>Net Price</Trans>: <Typography variant="body2" component="span" className="pvp-price"> <Trans>* Request price</Trans> €</Typography></div>
                              ) 
                            }
                            </Typography>
                          )
                        
                    ) : (
                      <div className="login-btn">
                        <a href="#" data-toggle="modal" data-target="#userModal"><Trans>You must be logged in</Trans></a>
                      </div>
                    )
                  }

                  {
                    logged && in_offer && (
                      <div className="offer-upto">
                        <Typography variant="body2" component="span" className="date-txt">{in_offer_until}</Typography>
                        <Typography variant="body2" component="span" className="valid-txt"><Trans>VALID_UNTIL</Trans></Typography>
                      </div>
                    )}
                </div>
              </div>
              {
                logged &&
                <div className="bottom-info">
                  {
                    stock <= 0 ? (
                      <div className="progress-wrapper">
                        <div className="stock-title"><Trans>Stock</Trans>:</div>
                        <div className="progress-title"><Trans>On request to manufacturer</Trans></div>
                        <div className="progressbar">
                          <div className="progressbar-inner" style={{ width: '2%' }}></div>
                        </div>
                      </div>
                    ) : (
                      stock < 10 ? (
                        <div className="progress-wrapper progress-low">
                          <div className="stock-title"><Trans>Stock</Trans>:</div>
                          <div className="progress-title"><Trans>Leftunits1</Trans> {stock} <Trans>Leftunits2</Trans></div>
                          <div className="progressbar">
                            <div className="progressbar-inner" style={{ width: (stock * 100 / 50) + `%` }}></div>

                          </div>
                        </div>
                      ) : (
                        stock >= 10 && stock < 50 ? (
                          <div className="progress-wrapper progress-medium">
                            <div className="stock-title"><Trans>Stock</Trans>:</div>
                            <div className="progress-title"><Trans>Leftunits1</Trans> {stock} <Trans>Leftunits2</Trans></div>
                            <div className="progressbar">
                              <div className="progressbar-inner" style={{ width: (stock * 100 / 50) + `%` }}></div>
                            </div>
                          </div>
                        ) : (
                          stock >= 50 && (
                            <div className="progress-wrapper progress-full">
                              <div className="stock-title"><Trans>Stock</Trans>:</div>
                              <div className="progress-title"><Trans>Leftunits1</Trans> {stock} <Trans>Leftunits2</Trans></div>
                              <div className="progressbar">
                                <div className="progressbar-inner" style={{ width: `100%` }}></div>
                              </div>
                            </div>
                          )
                        )
                      )
                    )
                  }

                  {/*
                    data?.not_discontinued?.raw == "false" ? (
                      <Typography className="btn graybg-btn" component="a" href={"/producto.php?cod_producto=" + data.id.raw}><Trans>Watch</Trans></Typography>
                    ) : (
                      <Typography className="btn bluebg-btn" component="a" href="#" data-toggle="modal" data-target="#modalAdd"><Trans>Add</Trans></Typography>
                    )
                    */
                  }
                  {data?.not_discontinued?.raw == "false" ? (
                                        <Typography
                                          className="btn graybg-btn"
                                          component="a"
                                          href={"/producto.php?cod_producto=" + data.id.raw}
                                        >
                                          <Trans>Watch</Trans>
                                        </Typography>
                                      ) : customFilterManufacturerIds.includes(JSON.parse(data.product_data.raw).manufacturer_id)  ? (
                                        <></>
                                      ) : (
                                        <>
                                          <ul className="cardBtn">
                                            {JSON.stringify(this.state.cart_product_ids).includes(
                                              data.id.raw
                                            ) ? (
                                              <CustomAddButton
                                                data={data}
                                                jwt={jwt}
                                                api_url={api_url}
                                                api_origin={api_origin}
                                                cart_prods={this.state.cart_products.prods_q}
                                                removeIdFromArr={this.removeIdFromArr}
                                                addIdFromArr={this.addIdFromArr}
                                                client_country_id={client_country_id}
                                              />
                                            ) : sendAddEvent ? (
                                              <Typography
                                                className={
                                                  "btn bluebg-btn addCarro toast-link " +
                                                  (this.state.sa ? "cust" : "")
                                                }
                                                component="a"
                                                onMouseDown={(event) => {
                                                  event.preventDefault();
                                                  this.sentEventData("AddProductEvent", {
                                                    product_id: data.id.raw,
                                                    quantity: 1,
                                                  });
                                                }}
                                                data-toast={`toast-${data.id.raw}`}
                                                data-producto={data.id.raw}
                                                data-value1={
                                                  JSON.parse(data.product_data.raw)
                                                    .manufacturer_id
                                                }
                                                data-value2={client_country_id}
                                              >
                                                <Trans>Add to</Trans>
                                              </Typography>
                                            ) : (
                                              <Typography
                                                className={
                                                  "btn bluebg-btn addCarro toast-link " +
                                                  (this.state.sa ? "cust" : "")
                                                }
                                                component="a"
                                                onClick={(event) => {
                                                  event.preventDefault();
                                                  this.productHandler(
                                                    data.id.raw,
                                                    JSON.parse(data.product_data.raw)
                                                      .manufacturer_id
                                                  );
                                                }}
                                                data-toast={`toast-${data.id.raw}`}
                                                data-producto={data.id.raw}
                                                data-value1={
                                                  JSON.parse(data.product_data.raw)
                                                    .manufacturer_id
                                                }
                                                data-value2={client_country_id}
                                              >
                                                <Trans>Add to</Trans>
                                              </Typography>
                                            )}
                                            {!sendAddEvent ? (
                                              <AddToListButton
                                                jwt={jwt}
                                                data={data}
                                                api_origin={api_origin}
                                                api_url={api_url}
                                              />
                                            ) : (
                                              <></>
                                            )}
                                          </ul>
                                        </>
                                      )}
                </div>
              }
            </div>
          </a>
        </TableCell>
        {/*selectProductId ? 
          <CustomToaster
            data={this.state.data}
            alertType={this.state.alertType}
            headContent={this.state.headContent}
            sId={data.id.raw}
            listId={false}
          />
            : ""*/}

      </>
    );
  }
}

export default withStyles(styles)(withTranslation()(ProductListCard));